export default __webpack_public_path__ + "static/media/bg_test.4eed1c05.png";